// src/components/ui/Avatar.tsx — brass-disc monogram avatar.
import { C, F } from "../../theme";

export type AvatarTone = "brass" | "heather" | "sage" | "signal";

export interface AvatarProps {
  first?: string;
  last?: string;
  size?: number;
  tone?: AvatarTone;
}

const tones: Record<AvatarTone, { bg: string; fg: string }> = {
  brass:   { bg: `linear-gradient(135deg, ${C.brassLt}, ${C.brass})`, fg: "#FFFCEC" },
  heather: { bg: `linear-gradient(135deg, #A88BB7, ${C.heather})`,    fg: "#FFFCEC" },
  sage:    { bg: `linear-gradient(135deg, #9DB59F, ${C.sage})`,       fg: "#FFFCEC" },
  signal:  { bg: `linear-gradient(135deg, #D08378, ${C.signal})`,     fg: "#FFFCEC" },
};

export const Avatar = ({ first = "", last = "", size = 44, tone = "brass" }: AvatarProps) => {
  const t = tones[tone];
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size / 3.4,
        background: t.bg,
        color: t.fg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: F.serif,
        fontWeight: 700,
        fontSize: size * 0.4,
        flexShrink: 0,
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.3), 0 1px 2px rgba(122,84,11,0.18)",
        letterSpacing: 0,
      }}
    >
      {(first[0] || "") + (last[0] || "")}
    </div>
  );
};
